import React from 'react';
import { Stack, Avatar, Typography, Link } from '@mui/material';

const PlateTextField = ({ transmission, plate, subValue,  sx = {}, size = 42, color = 'text.primary', onClick }) => {
  const isClickable = typeof onClick === 'function';

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {transmission && (
        <Avatar
          sx={{
            height: size,
            width: size,
            fontWeight: 500,
          }}
        >
          {transmission}
        </Avatar>
      )}
      <Stack spacing={0.25} sx={{ ...sx }}>
        {isClickable ? (
          <Link
            component="button"
            variant="subtitle2"
            onClick={onClick}
            color='inherit'
            underline="hover"
          >
            {plate}
          </Link>
        ) : (
          <Typography
            variant="subtitle2"
            color={color}
          >
            {plate}
          </Typography>
        )}
        {subValue && (
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary' }}
          >
            {subValue}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default PlateTextField;
